import { useContentDetail } from '@/hooks/useContentQueries';
import { getContentTypeIcon } from '@/lib/content-labels';
import type { CaptureRound } from '@/store/useCaptureFlowStore';
import { OBSERVATION_CAPTURE_LABELS as L } from './labels';

function CaptureSessionRow({ contentId }: { contentId: number }) {
  const detail = useContentDetail(contentId);
  const Icon = getContentTypeIcon(detail.data?.contentType);
  const title = detail.data?.title?.trim();
  return (
    <li className="flex items-center gap-2 text-xs text-muted-foreground">
      <Icon className="h-3.5 w-3.5 shrink-0" />
      <span className="truncate">{title && title.length > 0 ? title : L.session.itemFallback(contentId)}</span>
    </li>
  );
}

export function CaptureSessionList({ rounds }: { rounds: CaptureRound[] }) {
  const photoIds = rounds.flatMap((round) => round.photoIds);
  const recordingIds = rounds.flatMap((round) => round.recordingIds);
  const videoIds = rounds.flatMap((round) => round.videoIds);
  return (
    <div className="space-y-1 rounded border bg-muted/30 p-2">
      <p className="text-xs font-medium">{L.session.heading}</p>
      <ul className="space-y-1">
        {photoIds.map((contentId) => (
          <CaptureSessionRow key={`photo-${contentId}`} contentId={contentId} />
        ))}
        {recordingIds.map((contentId) => (
          <CaptureSessionRow key={`recording-${contentId}`} contentId={contentId} />
        ))}
        {videoIds.map((contentId) => (
          <CaptureSessionRow key={`video-${contentId}`} contentId={contentId} />
        ))}
      </ul>
    </div>
  );
}
